import { Link } from "react-router-dom";
import { assimagraLogoWhite, authBackground, poweredTech2c } from "@/assets";
import { useLanguage } from "../contexts/LanguageContext";
import { LanguageToggle } from "../components/LanguageToggle";
import { ParticipationForm } from "@/components/auth/ParticipationForm";

const ParticipationPage = () => {
  const { t } = useLanguage();

  return (
    <div className="flex min-h-screen">
      {/* Language toggle - fixed position */}
      <div className="fixed top-4 right-4 z-50">
        <LanguageToggle />
      </div>

      {/* Left side with background image and logo */}
      <div
        className="hidden [@media(min-width:1200px)]:flex [@media(min-width:1200px)]:w-1/2 relative p-8 flex-col justify-between overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url("${authBackground}")`,
          backgroundSize: "120% auto",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="flex flex-col text-white">
          <img src={assimagraLogoWhite} alt="ASSIMAGRA" className="w-80 h-auto mb-12 brightness-[1.15] saturate-0" />
          <h1 className="text-4xl font-bold leading-tight" style={{ textShadow: "3px 4px 8px rgba(0, 0, 0, 0.4)" }}>
            {t("auth.login.pageTitle.line1")}
            <br />
            {t("auth.login.pageTitle.line2")}
            <br />
            {t("auth.login.pageTitle.line3")}
          </h1>
        </div>

        {/* Footer section */}
        <div className="flex items-end justify-between">
          {/* Footer links */}
          <div className="flex items-center space-x-4 text-sm text-white/80">
            <Link to="/privacy" className="hover:text-white">
              {t("footer.privacy")}
            </Link>
            <span>•</span>
            <Link to="/terms" className="hover:text-white">
              {t("footer.terms")}
            </Link>
            <span>•</span>
            <Link to="/help" className="hover:text-white">
              {t("footer.help")}
            </Link>
          </div>

          {/* Powered by TECH2C */}
          <div className="flex items-end">
            <img src={poweredTech2c} alt="Powered by TECH2C" className="h-9" />
          </div>
        </div>
      </div>

      {/* Right side with participation form */}
      <div className="w-full [@media(min-width:1200px)]:w-1/2 p-8 flex flex-col">
        <div className="flex-grow flex items-center justify-center">
          <div className="w-full max-w-md">
            <ParticipationForm />
          </div>
        </div>

        {/* Footer logos */}
        <div className="flex justify-center items-center space-x-8 mt-8">
          <img src="/assets/logos/assimagra/logo-small.png" alt="ASSIMAGRA" className="h-8" />
          <img src="/assets/logos/footer/sustainable-stone.png" alt="Sustainable Stone" className="h-8" />
          <img src="/assets/logos/footer/prr.png" alt="PRR" className="h-8" />
          <img src="/assets/logos/footer/portuguese_republic.png" alt="Portuguese Republic" className="h-8" />
          <img src="/assets/logos/footer/UE.png" alt="European Union" className="h-8" />
        </div>
      </div>
    </div>
  );
};

export default ParticipationPage;
